import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    backgroundColor: theme.palette.tabHeaderBackground
  },
  dialogTitle: {
    color: theme.palette.blue_300.main
  },

  multFieldLine: {
    display: 'flex',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1)
    }
  },

  btnWrapper: {
    position: 'relative'
  },

  buttonProgress: {
    color: theme.palette.green_200.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  }
}))
